import LillyLogo from "../../assets/logo/logo.svg";
const toasterMessage = (text: string, buttonText?: string) => {
  return {
    description: (
      <div className="flex items-center gap-2">
        <img src={LillyLogo} alt="Lilly Logo" className="w-14" />
        <span className="text-muted-foreground font-medium text-sm">
          {text}
        </span>
      </div>
    ),
  };
};
export default toasterMessage;
